var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAssignmentInd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.556,
    viewBox: "0 0 14 15.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_assignment_ind_24px",
    d: "M15.444,2.556H12.193a2.324,2.324,0,0,0-4.387,0H4.556A1.56,1.56,0,0,0,3,4.111V15a1.56,1.56,0,0,0,1.556,1.556H15.444A1.56,1.56,0,0,0,17,15V4.111A1.56,1.56,0,0,0,15.444,2.556ZM10,2.556a.778.778,0,1,1-.778.778A.78.78,0,0,1,10,2.556Zm0,3.111A2.333,2.333,0,1,1,7.667,8,2.33,2.33,0,0,1,10,5.667ZM14.667,15H5.333V13.911C5.333,12.356,8.444,11.5,10,11.5s4.667.856,4.667,2.411Z",
    transform: "translate(-3 -1)",
    fill: "#4d4d4f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssignmentInd);
export default __webpack_public_path__ + "static/media/ic_assignment_ind.f0bf377bdfaef7ab25eaf3ad44223c60.svg";
export { ForwardRef as ReactComponent };